import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { translate } from 'helpers/translateHelper';
import { formatDateTime } from 'helpers/dateTimeFormatter';
import TrendCommentsModalDateTimeSection from './TrendCommentsModalDateTimeSection';
import TrendCommentsModalSignalSelectionSection from './TrendCommentsModalSignalSelectionSection';
import TrendCommentsModalCommentFields from './TrendCommentsModalCommentFields';

const TrendCommentsModalCommentForm = ({
    formData,
    errors,
    handleChange,
    datePickerVisibility,
    minDate,
    maxDate,
    graphCommentTimestamp,
    selectedTrendKPIs,
    trendKPIsList,
    showSignalSelector,
    showVisibilityToggle
}) => {
    return (
        <Row className='comment-input-section'>
            {graphCommentTimestamp ?
                <Col>
                    <div className='selected-data-point'>
                        <span>{translate('ABB.Powertrain.Frontend.opTrendCommentsTime')}:</span>
                        <span>{formatDateTime(graphCommentTimestamp)}</span>
                    </div>
                </Col>
                :
                <TrendCommentsModalDateTimeSection
                    formData={formData}
                    errors={errors}
                    handleChange={handleChange}
                    datePickerVisibility={datePickerVisibility}
                    minDate={minDate}
                    maxDate={maxDate}
                />
            }
            <TrendCommentsModalSignalSelectionSection
                formData={formData}
                errors={errors}
                handleChange={handleChange}
                selectedTrendKPIs={selectedTrendKPIs}
                trendKPIsList={trendKPIsList}
                showSignalSelector={showSignalSelector}
            />
            <TrendCommentsModalCommentFields
                formData={formData}
                errors={errors}
                handleChange={handleChange}
                showVisibilityToggle={showVisibilityToggle}
            />
        </Row>
    );
};

TrendCommentsModalCommentForm.propTypes = {
    formData: PropTypes.object,
    errors: PropTypes.object,
    handleChange: PropTypes.func,
    datePickerVisibility: PropTypes.object,
    minDate: PropTypes.string,
    maxDate: PropTypes.string,
    graphCommentTimestamp: PropTypes.string,
    selectedTrendKPIs: PropTypes.array,
    trendKPIsList: PropTypes.array,
    showSignalSelector: PropTypes.bool,
    showVisibilityToggle: PropTypes.bool
};

export default TrendCommentsModalCommentForm;
